export type AnalysisLevel = 'good' | 'normal' | 'bad';

interface AnalysisData {
  label: string;
  summary: string;
  detail: string;
  briefing: string;
}

export const aiAnalysisData: Record<AnalysisLevel, AnalysisData> = {
  good: {
    label: '좋음',
    briefing: '이번 주는 평소보다 기운이 날 거예요!',
    summary: '이번 주는 평소보다 기운이 날 거예요! 평소보다 조금 더 발걸음을 옮겨보아요.',
    detail: `이번 주는 평소보다 피로가 덜하고, 숨도 조금 여유롭게 쉴 수 있는 날이에요.
이럴 때는 작은 외출이나 즐거운 만남처럼, 평소 병원과 직장 생활로 미뤄뒀던 '마음이 환해지는 일'을 해보세요.

예를 들어, 동네를 천천히 산책하거나, 보고 싶었던 사람과 따뜻한 차 한 잔을 나누는 것처럼요.
업무에서도 가벼운 정리나 협업처럼, 기분 좋은 교류가 있는 일을 하는 것도 좋습니다.

이번 주 적립한 행복이 다음 주의 에너지가 되어 줄 거예요.
이번 주도 응원해요!`,
  },
  normal: {
    label: '보통',
    briefing: '평온함 속에서 안정을 찾길 바라요.',
    summary: '평온함 속에서 안정을 찾길 바라요. 무리하지 않고, 마음과 몸의 속도를 맞춰주세요.',
    detail: `몸 상태가 나쁘진 않지만, 그렇다고 완전히 가벼운 날은 아니죠. 
이런 주는 ‘해야 할 일’을 전부 다 끝내기보다, 중요도 순으로 우선순위를 정하고 하나씩만 해도 충분합니다.
점심 이후 졸음이 몰려오면, 잠시 눈을 감고 호흡을 고르며 3~5분만 쉬어도 머리가 맑아질 거예요.

‘이번 주는 내 몸을 지키는 날’이라는 생각으로, 회복을 위한 여유를 스스로 허락해주세요. 
다음 주의 나를 위한 최고의 배려입니다.
물론, 생각치 못한 변수로 마음만큼 되지 않더라도 너무 낙심하지 말자구요!`,
  },
  bad: {
    label: '나쁨',
    briefing: '이번 주는 잠시 숨 고르기를 해도 괜찮아요.',
    summary: '이번 주는 잠시 멈추고, 숨 고르기를 해도 괜찮아요. 아기와 나를 위한 ‘느린 하루’를 보내주세요.',
    detail: `몸이 무겁거나, 집중이 잘 안 되고, 업무 속도가 평소보다 느린 주가 있죠.
임신 중에는 호르몬 변화와 피로가 겹쳐, 특히 직장에서 이런 날이 더 자주 찾아옵니다.

이럴 때는 ‘효율보다 안전’을 우선하세요. 중요한 업무가 있다면 상사나 동료에게 현재 컨디션을 솔직하게 알리고 협조를 구하는 것도 권고드려요.

책상에 앉아 있는 시간이 길다면, 1시간마다 자리에서 일어나 스트레칭을 하는 것은 어떨까요?

이번 주는 ‘최소한의 일’만 해도 최선을 다한 날이에요.
몸이 보내는 신호에 귀 기울이며, 퇴근 후엔 가벼운 샤워와 조용한 휴식으로 하루를 마무리하세요. 다음 주는 더 나아질 거예요.`,
  },
};
